module.exports = __webpack_public_path__ + "img/0f78de9.jpg";